import styles from "./ArticleContent.module.scss";
import cx from "classnames";
import gql from "graphql-tag";
import { ArticleContentFragment } from "types/api";
import useImperativeLazyLoad from "utils/useImperativeLazyLoad";

const ArticleContent = ({ main }: ArticleContentFragment) => {
  const lazyRef = useImperativeLazyLoad();
  return (
    // Add .fonts-loaded so house ads render correctly without a ton of individual overrides
    <section
      className={cx(styles.root, `fonts-loaded`)}
      dangerouslySetInnerHTML={{ __html: main }}
      ref={lazyRef}
    />
  );
};

ArticleContent.fragment = gql`
  fragment articleContent on ContentSection {
    main
    hasRailAd
  }
`;

export default ArticleContent;
